import { IAnnuityTable, IEmployerOneTimeContribution, IFoldConst, IGender, IValues, TRetirementAge } from './types'

export const genders: IGender[] = [
  { title: 'М', value: 'm' },
  { title: 'Ж', value: 'f' },
]

export const retirementAges: TRetirementAge = {
  m: 65,
  f: 60,
}

export const minAge = 18

export const maxExperiences: TRetirementAge = {
  m: 47,
  f: 42,
}

export const contributionSteps = [0.8, 0.9, 1, 2, 3, 4, 5]

export const defaultValues: IValues = {
  gender: 'm',
  age: 30,
  salary: 35000,
  income: 50000,
  exp: 1,
  percentContribution: 3,
}

export const maximumContribution = 5

export const folders: IFoldConst[] = [
  {
    heading: 'По личному договору',
    desc: 'Срочная выплата пенсии в течение 5 лет',
    valueDesc: 'Будет накоплено на ИПС к пенсионному возрасту',
    firstOptionTitle:
      'Первая выплата в размере 25% от накопленной суммы, далее в виде ежемесячной срочной пенсии в течение 5 лет',
    secondOptionTitle: 'Выплата негосударственной пенсии осуществляется ежемесячно равными долями сроком на 5 лет',
    firstOptionPaymentDesc: 'Размер первой выплаты (25% от накоплений суммы на ИПС)',
    firstOptionPensionDesc: 'Размер ежемесячной срочной пенсии (оставшийся срок — 59 месяцев)',
    secondOptionPensionDesc: 'Размер ежемесячной пенсии',
    taxed: false,
  },
  {
    heading: 'На КИПС участника',
    desc: 'Пожизненная выплата',
    valueDesc: 'Будет накоплено на КИПС к пенсионному возрасту',
    firstOptionTitle: 'Первая выплата в размере 25% от накопленной суммы, далее в виде ежемесячной пожизненной пенсии',
    secondOptionTitle: 'Выплата негосударственной пенсии осуществляется ежемесячно и пожизненно, равными долями',
    firstOptionPaymentDesc: 'К пенсионному возрасту сформированапервая выплата (25% от накоплений)',
    firstOptionPensionDesc:
      'К пенсионному возрасту сформирована ежемесячная пожизненная пенсия (выплата осуществляется со второго месяца назначения)',
    secondOptionPensionDesc: 'Размер ежемесячной пенсии',
    taxed: true,
  },
  {
    heading: 'По КЕПВ участника',
    desc: 'Срочная выплата пенсии в течение 5 лет',
    valueDesc: 'Сумма единовременного взноса на КЕПВ',
    firstOptionTitle:
      'Первая выплата в размере 25% от накопленной суммы, далее в виде ежемесячной срочной пенсии в течение 5 лет',
    secondOptionTitle: 'Выплата негосударственной пенсии осуществляется ежемесячно равными долями сроком на 5 лет',
    firstOptionPaymentDesc: 'К пенсионному возрасту сформирована первая выплата (25% от суммы накоплений на КЕПВ)',
    firstOptionPensionDesc:
      'К пенсионному возрасту сформирована ежемесячная срочная пенсия (на оставшийся срок — 59 месяцев)',
    secondOptionPensionDesc: 'Размер ежемесячной пенсии',
    taxed: true,
  },
]

export const employerOneTimeContribution: IEmployerOneTimeContribution[] = [
  { m: 0, f: 0, contribution: 0 },
  { m: 12, f: 7, contribution: 1 },
  { m: 13, f: 8, contribution: 1.5 },
  { m: 14, f: 9, contribution: 2 },
  { m: 15, f: 10, contribution: 2.5 },
  { m: 16, f: 11, contribution: 3 },
  { m: 17, f: 12, contribution: 3.5 },
  { m: 18, f: 13, contribution: 4 },
  { m: 19, f: 14, contribution: 4.5 },
  { m: 20, f: 15, contribution: 5 },
  { m: 21, f: 16, contribution: 5.5 },
  { m: 22, f: 17, contribution: 6 },
  { m: 23, f: 18, contribution: 6.5 },
  { m: 24, f: 19, contribution: 7 },
  { m: 25, f: 20, contribution: 7.5 },
  { m: 26, f: 21, contribution: 8 },
  { m: 27, f: 22, contribution: 8.5 },
  { m: 28, f: 23, contribution: 9 },
  { m: 29, f: 24, contribution: 9.5 },
  { m: 30, f: 25, contribution: 10 },
]

export const annuityTable: IAnnuityTable[] = [
  { age: 0, m: 278.978, f: 290.824 },
  { age: 1, m: 280.193, f: 292.086 },
  { age: 2, m: 279.135, f: 291.466 },
  { age: 3, m: 277.949, f: 290.753 },
  { age: 4, m: 276.699, f: 289.994 },
  { age: 5, m: 275.373, f: 289.189 },
  { age: 6, m: 273.991, f: 288.344 },
  { age: 7, m: 272.545, f: 287.455 },
  { age: 8, m: 271.041, f: 286.534 },
  { age: 9, m: 269.473, f: 285.573 },
  { age: 10, m: 267.862, f: 284.568 },
  { age: 11, m: 266.174, f: 283.522 },
  { age: 12, m: 264.427, f: 282.431 },
  { age: 13, m: 262.599, f: 281.308 },
  { age: 14, m: 260.712, f: 280.129 },
  { age: 15, m: 258.803, f: 278.941 },
  { age: 16, m: 256.839, f: 277.714 },
  { age: 17, m: 254.839, f: 276.466 },
  { age: 18, m: 252.817, f: 275.167 },
  { age: 19, m: 250.789, f: 273.832 },
  { age: 20, m: 248.71, f: 272.441 },
  { age: 21, m: 246.632, f: 271.007 },
  { age: 22, m: 244.514, f: 269.525 },
  { age: 23, m: 242.35, f: 267.99 },
  { age: 24, m: 240.129, f: 266.405 },
  { age: 25, m: 237.902, f: 264.783 },
  { age: 26, m: 235.658, f: 263.124 },
  { age: 27, m: 233.381, f: 261.427 },
  { age: 28, m: 231.047, f: 259.671 },
  { age: 29, m: 228.688, f: 257.891 },
  { age: 30, m: 226.359, f: 256.069 },
  { age: 31, m: 224.077, f: 254.224 },
  { age: 32, m: 221.756, f: 252.359 },
  { age: 33, m: 219.42, f: 250.418 },
  { age: 34, m: 217.089, f: 248.429 },
  { age: 35, m: 214.785, f: 246.417 },
  { age: 36, m: 212.427, f: 244.33 },
  { age: 37, m: 209.982, f: 242.154 },
  { age: 38, m: 207.463, f: 239.902 },
  { age: 39, m: 204.829, f: 237.558 },
  { age: 40, m: 202.133, f: 235.175 },
  { age: 41, m: 199.343, f: 232.723 },
  { age: 42, m: 196.461, f: 230.2 },
  { age: 43, m: 193.425, f: 227.544 },
  { age: 44, m: 190.319, f: 224.83 },
  { age: 45, m: 187.158, f: 222.039 },
  { age: 46, m: 183.982, f: 219.171 },
  { age: 47, m: 180.766, f: 216.248 },
  { age: 48, m: 177.457, f: 213.197 },
  { age: 49, m: 174.075, f: 210.047 },
  { age: 50, m: 170.724, f: 206.806 },
  { age: 51, m: 167.346, f: 203.495 },
  { age: 52, m: 163.937, f: 200.096 },
  { age: 53, m: 160.403, f: 196.601 },
  { age: 54, m: 156.858, f: 193.004 },
  { age: 55, m: 153.388, f: 189.352 },
  { age: 56, m: 149.908, f: 185.699 },
  { age: 57, m: 146.398, f: 181.924 },
  { age: 58, m: 142.918, f: 178.047 },
  { age: 59, m: 139.447, f: 174.128 },
  { age: 60, m: 135.923, f: 170.117 },
  { age: 61, m: 132.676, f: 165.979 },
  { age: 62, m: 129.53, f: 161.863 },
  { age: 63, m: 126.157, f: 157.617 },
  { age: 64, m: 122.746, f: 153.304 },
  { age: 65, m: 119.69, f: 149.038 },
  { age: 66, m: 115.979, f: 144.448 },
  { age: 67, m: 113.038, f: 140.223 },
  { age: 68, m: 109.341, f: 135.522 },
  { age: 69, m: 105.778, f: 130.859 },
  { age: 70, m: 102.29, f: 126.132 },
  { age: 71, m: 98.328, f: 121.137 },
  { age: 72, m: 95.47, f: 116.627 },
  { age: 73, m: 92.035, f: 111.729 },
  { age: 74, m: 88.735, f: 106.951 },
  { age: 75, m: 85.865, f: 102.349 },
  { age: 76, m: 82.615, f: 97.53 },
  { age: 77, m: 79.616, f: 92.931 },
  { age: 78, m: 76.673, f: 88.5 },
  { age: 79, m: 73.846, f: 84.22 },
  { age: 80, m: 70.906, f: 79.776 },
  { age: 81, m: 68.174, f: 75.613 },
  { age: 82, m: 65.731, f: 71.765 },
  { age: 83, m: 63.147, f: 67.902 },
  { age: 84, m: 60.96, f: 64.291 },
  { age: 85, m: 59.06, f: 60.806 },
  { age: 86, m: 57.487, f: 57.76 },
  { age: 87, m: 55.843, f: 54.72 },
  { age: 88, m: 54.044, f: 51.856 },
  { age: 89, m: 52.093, f: 49.093 },
  { age: 90, m: 50.286, f: 46.702 },
  { age: 91, m: 47.498, f: 43.979 },
  { age: 92, m: 45.687, f: 41.767 },
  { age: 93, m: 43.028, f: 39.171 },
  { age: 94, m: 40.322, f: 36.751 },
  { age: 95, m: 38.638, f: 34.796 },
  { age: 96, m: 35.969, f: 32.41 },
  { age: 97, m: 31.954, f: 29.274 },
  { age: 98, m: 27.094, f: 25.338 },
  { age: 99, m: 20.849, f: 20.007 },
  { age: 100, m: 12.0, f: 12 },
]
